import "./form-control-handlers"

export { registerFormControlHandler, doFormControlHandler } from "./form-control-handler"
export type { default as FormControlHandler } from "./form-control-handler"
